export const actionTypes = {
  SELLOUT_GET_FILE_PENDING_APPROVALS: "SELLOUT_GET_FILE_PENDING_APPROVALS",
  SELLOUT_SET_FILE_PENDING_APPROVALS: "SELLOUT_SET_FILE_PENDING_APPROVALS",
  SELLOUT_APPROVE_OR_REJECT_FILES: "SELLOUT_APPROVE_OR_REJECT_FILES",
  SELLOUT_GET_FILTERED_APPROVALS: "SELLOUT_GET_FILTERED_APPROVALS",
};

export const actions = {
  getFilesPendingApprovals: (payload) => ({
    type: actionTypes.SELLOUT_GET_FILE_PENDING_APPROVALS,
    payload: payload,
  }),

  setFilesPendingApprovals: (payload) => ({
    type: actionTypes.SELLOUT_SET_FILE_PENDING_APPROVALS,
    payload: payload,
  }),

  approveOrRejectFiles: (payload) => ({
    type: actionTypes.SELLOUT_APPROVE_OR_REJECT_FILES,
    payload: payload,
  }),

  getFilteredApprovals: (payload) => ({
    type: actionTypes.SELLOUT_GET_FILTERED_APPROVALS,
    payload: payload,
  }),
};
